import { Component, EventEmitter, Output } from '@angular/core';
import { Tab } from 'shared.models/tabbed-table.model';

@Component({
  selector: '[nc-tabbed-container]',
  templateUrl: './tabbed-container.component.html',
  standalone: false,
})

export class TabbedContainerComponent {
  tabs: Tab[] = [];
  @Output() tabSelected = new EventEmitter();

  addTab(tab: Tab): Tab[] {
    if (!this.tabs.length) {
      tab.tabSelected = true;
    }
    this.tabs.push(tab);
    return this.tabs.reverse();
  }

  selectTab(tab: Tab, event: Event): void {
    event.preventDefault();
    this.tabs.map((selectTab) => {
      selectTab.tabSelected = false;
    });
    tab.tabSelected = true;
    this.tabSelected.emit({ selectedTab: tab });
  }

  trackItem(__: number, item: Tab): string {
    if (!item) { return undefined; }

    return item.tabTitle;
  }
}
